module.exports = __webpack_public_path__ + "img/2xiao.f4033fe8.png";